// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.b0OSTR7tcXFHlOIs2aqM{width:100%;height:100%;position:relative}.wufRxlRDGY5tFWDAzG8e{border:1px solid var(--action-outlined-tertiary-border);background:var(--background-primary-inverted-primary);border-radius:4px;padding:2px}.OLp_oKhqpEY7M5yeBeDr{background:var(--background-neutral-default);width:24px;height:24px;color:var(--content-primary-primary);border-radius:6px;justify-content:center;align-items:center;font-size:13px;font-weight:400;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableContainer": `b0OSTR7tcXFHlOIs2aqM`,
	"icon": `wufRxlRDGY5tFWDAzG8e`,
	"duplicatesCount": `OLp_oKhqpEY7M5yeBeDr`
};
export default ___CSS_LOADER_EXPORT___;
